import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getDashboards } from "services/BookingService";
const Dashboard = () => {
  const [stats, setStats] = useState([]);
  const stats1 = [
    { icon: 'fa-user', count: 11, title: 'Total Agent' },
    { icon: 'fa-building', count: 4, title: 'Total Hotels' },
    { icon: 'fa-hotel', count: 5, title: 'Total Booking' },
    { icon: 'fa-hotel', count: 11, title: 'Today Booking' } , 
    { icon: 'fa-hotel', count: 7, title: 'Today Billing' }  ,
    { icon: 'fa-hotel', count: 7, title: 'Total Billing' },   
  ];
  
    useEffect(() => {
      getDashboardList();
    }, []);

   const getDashboardList = () => {
    getDashboards().then((response) => {
          if (response && response.data.success) {
            setStats(response.data.stats);
            
          }
        });
      };
    
 return (
  <>
  <section class="content-header">
  <div class="header-icon">
     <i class="fa fa-dashboard"></i>
  </div>
  <div class="header-title">
     <h1>Delight STAY</h1>
     <small>Hotel Manage admin Panel.</small>
  </div>
</section>
  <section className="content">
  <div className="row">
    {stats.map((stat, idx) => (
      <div key={idx} className="col-sm-6 col-md-6 col-lg-4">
        <div id={`cardbox${idx + 1}`}>
          <div className="statistic-box">
            <i className={`fa ${stat.icon} fa-3x`}></i>
            <div className="counter-number pull-right">
              <span className="count-number">{stat.count}</span>
              <span className="slight"><i className="fa fa-play fa-rotate-270"></i></span>
            </div>
            <h3>{stat.title}</h3>
          </div>
        </div>
      </div>
    ))}
  </div>
</section>
</>
)};

export default Dashboard;
